import { Controller } from '@hotwired/stimulus'

// Handles billing filter form submission and pagination via fetch,
// replacing the table without relying on Turbo Frame mechanics.
export default class extends Controller {
  static targets = ['output']

  connect() {
    this.handlePaginationClick = this.handlePaginationClick.bind(this)
    this.outputTarget.addEventListener('click', this.handlePaginationClick)
  }

  disconnect() {
    this.outputTarget.removeEventListener('click', this.handlePaginationClick)
  }

  submit(event) {
    event.preventDefault()

    const form = event.target
    const url = new URL(form.action)
    const formData = new FormData(form)

    for (const [key, value] of formData.entries()) {
      if (value) url.searchParams.set(key, value)
    }

    this.fetchAndReplace(url.toString())
  }

  handlePaginationClick(event) {
    const link = event.target.closest('.pagy-nav a')
    if (!link) return

    event.preventDefault()
    this.fetchAndReplace(link.href)
  }

  fetchAndReplace(url) {
    this.outputTarget.style.opacity = '0.5'

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(url, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
        ...(csrfToken && { 'X-CSRF-Token': csrfToken })
      },
      credentials: 'same-origin'
    })
      .then(response => {
        if (!response.ok) throw new Error(`Filter request failed: ${response.status}`)
        return response.text()
      })
      .then(html => {
        this.outputTarget.innerHTML = html
        this.outputTarget.style.opacity = '1'
      })
      .catch(error => {
        console.error('[BillingFilter]', error)
        this.outputTarget.style.opacity = '1'
      })
  }
}
